export default {
    searchList: {
        searchTxt: [
            {
                name: '用户电话号码',
                value: 'mobile',
                type: 'input',
                unfold: true,
                span: 3
            },
            {
                name: '订单号',
                value: 'orderNo',
                type: 'input',
                unfold: true,
                span: 4
            },
            {
                name: '运单号',
                value: 'waybillNo',
                type: 'input',
                unfold: false
            },
            {
                name: '客户安装单号',
                value: 'customerInstallNo',
                type: 'input',
                unfold: false
            },
            {
                name: '订单状态',
                value: 'orderStatus',
                type: 'select',
                multiple: true,
                filterable: true,
                unfold: true,
                optionNum: 'NET_ORDER_STATUS',
                options: [],
                span: 5
            },
            {
                name: '接入时间',
                value: 'createTime',
                type: 'time',
                unfold: true,
                timeNum: 6,
                span: 7
            },
            {
                name: '更新时间',
                value: 'updateTime',
                type: 'time',
                unfold: false
            },
            {
                name: '看板状态',
                value: 'KanbanStatus',
                type: 'select',
                options: [
                    {
                        value: '0',
                        label: '待完结'
                    },
                    {
                        value: '1',
                        label: '超期10天内'
                    },
                    {
                        value: '2',
                        label: '超期20天内'
                    },
                    {
                        value: '3',
                        label: '超期30天内'
                    }
                ],
                unfold: false
            }
        ],
        unfoldState: false,
        advancedBtn: true,
        isControl: true
    },
    table: {
        selectBtn: true,
        fixedSeletionColumn: true,
        fixedIndexColumn: true,
        indexColumn: true,
        hasMaxBtnNum: true,
        leftOperation: true,
        maxBtnNum: 2,
        height: 400,
        leftWidth: 190,
        columns: [{
            label: '订单号',
            prop: 'orderNo',
            sort: true,
            width: '180px'
        },
        {
            label: '客户订单号',
            prop: 'customerOrderNo',
            sort: true,
            width: '180px'
        },
        {
            label: '集配单号',
            prop: 'jpOrderNo',
            sort: true,
            width: '140px'
        },
        {
            label: '运单号',
            prop: 'waybillNo',
            sort: true,
            width: '140px'
        },
        {
            label: '服务单号',
            prop: 'serviceOrderNo',
            sort: true,
            width: '140px'
        },
        {
            label: '客户安装单号',
            prop: 'customerInstallNo',
            sort: true,
            width: '140px'
        },
        {
            label: '订单类型',
            prop: 'orderTypeName',
            sort: true,
            width: '96px'
        },
        {
            label: '订单状态',
            prop: 'orderStatusName',
            type: 'button',
            sort: true,
            width: '96px'
        },
        {
            label: '网点编码',
            prop: 'networkCode',
            sort: true,
            width: '110px'
        },
        {
            label: '网点名称',
            prop: 'networkName',
            sort: true,
            width: '148px'
        },
        {
            label: '来源平台',
            prop: 'tonetSiteName',
            sort: true,
            width: '110px'
        },
        {
            label: '电子签收标识',
            prop: 'deliveredVerifyFlagName',
            sort: true,
            width: '110px'
        },
        {
            label: '来源发车单号',
            prop: 'fromDispatchNo',
            sort: true,
            width: '148px'
        },
        {
            label: '来源系统',
            prop: 'sourceSystemName',
            sort: true,
            width: '96px'
        },
        {
            label: '上游下单时间',
            prop: 'upperOrderTime',
            sort: true,
            width: '148px'
        },
        {
            label: '用户要求送达时间',
            prop: 'expectArriveTime',
            sort: true,
            width: '210px'
        },
        {
            label: '用户期望安装时间',
            prop: 'expectInstallTime',
            sort: true,
            width: '210px'
        },
        {
            label: '首约时间',
            prop: 'firstAppointmentTime',
            sort: true,
            width: '210px'
        },
        {
            label: '网点改约次数',
            prop: 'appointmentCount',
            sort: true,
            width: '116px'
        },
        {
            label: '用户期望送装需求',
            prop: 'expectInstallTypeName',
            sort: true,
            width: '148px'
        },
        {
            label: '配送工程师',
            prop: 'engineerName',
            sort: true,
            width: '106px'
        },
        {
            label: '配送工程师编码',
            prop: 'engineerNo',
            width: '116px'
        },
        {
            label: '安装工程师',
            prop: 'installEngineerName',
            sort: true,
            width: '106px'
        },
        {
            label: '安装工程师编码',
            prop: 'installEngineerNo',
            width: '116px'
        },
        {
            label: '安装时间',
            prop: 'installCreateTime',
            sort: true,
            width: '148px'
        },
        {
            label: '网点预约送装模式',
            prop: 'factInstallTypeName',
            sort: true,
            width: '148px'
        },
        {
            label: '下发异常信息',
            prop: 'exceptionDescription',
            sort: true,
            width: '148px'
        },
        {
            label: '网点一级反馈项',
            prop: 'exceptionReason1Name',
            sort: true,
            width: '148px'
        },
        {
            label: '网点二级反馈项',
            prop: 'exceptionReason2Name',
            sort: true,
            width: '148px'
        },
        {
            label: '反馈备注',
            prop: 'exceptionRemark',
            sort: true,
            width: '148px'
        },
        {
            label: '异常反馈时间',
            prop: 'exceptionReasonTime',
            sort: true,
            width: '148px'
        },
        {
            label: '远程费用申请',
            prop: 'applyStatusName',
            sort: true,
            width: '120px'
        },
        {
            label: '店铺名称',
            prop: 'shopName',
            sort: true,
            width: '220px'
        },
        {
            label: '商品品类',
            prop: 'itemClassName',
            sort: true,
            width: '220px'
        },
        {
            label: '品牌',
            prop: 'brand',
            sort: true,
            width: '160px'
        },
        {
            label: '产品型号',
            prop: 'itemName',
            sort: true,
            width: '160px'
        },
        {
            label: '总数量',
            prop: 'totalQty',
            sort: true,
            width: '90px'
        },
        {
            label: '总体积',
            prop: 'totalVolume',
            sort: true,
            width: '90px'
        },
        {
            label: '总毛重',
            prop: 'totalGrossWeight',
            sort: true,
            width: '90px'
        },
        {
            label: '网点实收总体积',
            prop: 'netTotalReceivedVolume',
            sort: true,
            width: '126px'
        },
        {
            label: '收货人',
            prop: 'receiverName',
            sort: true,
            width: '90px'
        },
        {
            label: '收货联系方式',
            prop: 'receiverMobile',
            sort: true,
            width: '148px'
        },
        {
            label: '收货详细地址',
            prop: 'receiverDetailAddr',
            sort: true,
            width: '148px'
        },
        {
            label: '收货市',
            prop: 'receiverCityName',
            sort: true,
            width: '148px'
        },
        {
            label: '收货区县',
            prop: 'receiverDistrictName',
            sort: true,
            width: '148px'
        },
        {
            label: '附件',
            prop: 'images',
            align: 'center',
            type: 'photos',
            width: '50px'
        },
        {
            label: '增值服务类型',
            prop: 'addedServiceTypeName',
            sort: true,
            width: '148px'
        },
        {
            label: '是否第三方',
            prop: 'thirdFlagName',
            sort: true,
            width: '120px'
        },
        {
            label: '是否需要通电验机',
            prop: 'addedserviceType2CName',
            sort: true,
            width: '148px'
        },
        {
            label: '接入时间',
            prop: 'createTime',
            sort: true,
            width: '148px'
        },
        {
            label: '商超标识',
            prop: 'scPosFlagName',
            sort: true,
            width: '148px'
        },
        {
            label: '国苏直营标识',
            prop: 'projectClassifyName',
            sort: true,
            width: '148px'
        },
        {
            label: '退换机',
            prop: 'serviceTypeName',
            sort: true,
            width: '148px'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            sort: true,
            width: '148px'
        },
        {
            label: '业务模式',
            prop: 'businessMode',
            sort: true,
            width: '148px'
        },
        {
            label: '配送方式',
            prop: 'deliveryTypeName',
            sort: true,
            width: '148px'
        },
        {
            label: '网点分中心',
            prop: 'networkCenterName',
            sort: true,
            width: '148px'
        },
        {
            label: '提货联系人',
            prop: 'senderName',
            sort: true,
            width: '148px'
        },
        {
            label: '提货联系方式',
            prop: 'senderTel',
            sort: true,
            width: '148px'
        },
        {
            label: '提货详细地址',
            prop: 'senderDetailAddr',
            sort: true,
            width: '148px'
        },
        {
            label: '网点预约时间',
            prop: 'networkAppointmentTime',
            sort: true,
            width: '210px'
        },
        {
            label: '网点预约备注',
            prop: 'networkAppointmentRemark',
            sort: true,
            width: '160px'
        },
        {
            label: '网点签收时间',
            prop: 'networkSignTime',
            sort: true,
            width: '160px'
        },
        {
            label: '用户签收时间',
            prop: 'finalSignTime',
            sort: true,
            width: '160px'
        },
        {
            label: '安装状态',
            prop: 'installName',
            sort: true,
            width: '96px'
        },
        {
            label: '支线应到达时间',
            prop: 'networkArrivePlanTime',
            sort: true,
            width: '160px'
        },
        {
            label: '时效要求送达时间',
            prop: 'finalSignPlanTime',
            sort: true,
            width: '160px'
        },
        {
            label: '上门取件应完成时间',
            prop: 'requiredPickTime',
            sort: true,
            width: '160px'
        },
        {
            label: '预约安装时间',
            prop: 'installTime',
            sort: true,
            width: '210px'
        },
        {
            label: '是否精准配送',
            prop: 'isJzpName',
            sort: true,
            width: 120
        },
        {
            label: '菜鸟安装需求',
            prop: 'cnInstallFlagName',
            sort: true,
            width: 120
        }
        ],
        action: [{
            type: 'text',
            label: '网点签收',
            size: 'mini',
            event: 'branchSign',
            ifHas: '10030005'
        },
        {
            type: 'text',
            label: '预约',
            size: 'mini',
            event: 'appointment',
            ifHas: '10030006'
        },
        {
            type: 'text',
            label: '用户签收', // 2B
            size: 'mini',
            event: 'finalSign',
            ifHas: '10030007'
        },
        {
            type: 'text',
            label: '用户签收', // 2C
            size: 'mini',
            event: 'clientSign',
            ifHas: '10030008'
        },
        {
            type: 'text',
            label: '用户拒签',
            size: 'mini',
            event: 'clientReject',
            ifHas: '10030009'
        },
        {
            type: 'text',
            label: '取件',
            size: 'mini',
            event: 'pickup',
            ifHas: '10030010'
        },
        {
            type: 'text',
            label: '网点入库',
            size: 'mini',
            event: 'netInbound',
            ifHas: '10030011'
        },
        {
            type: 'text',
            label: '网点出库',
            size: 'mini',
            event: 'netOutbound',
            ifHas: '10030012'
        },
        {
            type: 'text',
            label: '审核', // 拒签审核
            size: 'mini',
            event: 'rejectConfirm',
            ifHas: '10030013'
        },
        {
            type: 'text',
            label: '审核',
            size: 'mini',
            event: 'pickupConfirm', // 取件失败审核
            ifHas: '10030014'
        },
        {
            type: 'text',
            label: '审核',
            size: 'mini',
            event: 'signConfirm', // 签收审核
            ifHas: ''
        },
        {
            type: 'text',
            label: '生成回退单',
            size: 'mini',
            event: 'createReturn',
            ifHas: '10030015'
        },
        {
            type: 'text',
            label: '费用申请',
            size: 'small',
            event: 'fundRequest',
            ifHas: '10030016'
        },
        {
            type: 'text',
            label: '打印',
            size: 'mini',
            event: 'print',
            ifHas: '10030017'
        },
        {
            type: 'text',
            label: '异常反馈',
            size: 'mini',
            event: 'feedback',
            ifHas: '10030018'
        },
        {
            type: 'text',
            label: '签收改拒收',
            size: 'mini',
            event: 'toReject',
            ifHas: '10030019'
        },
        {
            type: 'text',
            label: '网点拒收',
            size: 'mini',
            event: 'branchReject',
            ifHas: '10030023'
        }
        ]
    },
    page: {
        layout: 'total, sizes, prev, pager, next, jumper',
        pageSize: 50,
        pageSizes: [10, 20, 30, 50, 100]
    },
    searchTotalTitle: [{
        name: '预约开始时间',
        value: 'appointmentStartTime',
        type: 'time'
    },
    {
        name: '预约结束时间',
        value: 'appointmentEndTime',
        type: 'time'
    },
    {
        name: '上门取件时间',
        value: 'requiredPickTime',
        type: 'time'
    },
    {
        name: '服务完成时间',
        value: 'serviceTime',
        type: 'time'
    },
    {
        name: '来源发车单号',
        value: 'fromDispatchNo',
        type: 'input'
    },
    {
        name: '来源平台',
        value: 'tonetSiteName',
        advanceConfig: [{
            prop: 'escoCompanyNameCn',
            value: '来源平台名称'
        },
        {
            prop: 'escoCompanyNo',
            value: '来源平台编码'
        }
        ],
        tableConfig: [{
            prop: 'escoCompanyNo',
            value: '来源平台编码'
        },
        {
            prop: 'escoCompanyNameCn',
            value: '来源平台名称'
        }
        ],
        advanceUrl: '/searchPlatform',
        cbParams: ['escoCompanyNo#siteCode', 'escoCompanyNameCn#tonetSiteName'],
        type: 'advance'
    },
    {
        name: '网点上传状态',
        value: 'networkReceiptStatus',
        options: [{
            value: 'Y',
            label: '是'
        },
        {
            value: 'N',
            label: '否'
        }
        ],
        type: 'select'
    },
    {
        name: '终端上传状态',
        value: 'finalReceiptStatus',
        options: [{
            value: 'Y',
            label: '是'
        },
        {
            value: 'N',
            label: '否'
        }
        ],
        type: 'select'
    },
    {
        name: '业务模式',
        value: 'businessMode',
        options: [{
            value: 'B2C',
            label: 'B2C'
        },
        {
            value: 'B2B',
            label: 'B2B'
        }
        ],
        type: 'select'
    },
    {
        name: '拦截状态',
        value: 'interceptFlag',
        options: [{
            value: 0,
            label: '正常'
        },
        {
            value: 1,
            label: '拦截'
        }
        ],
        type: 'select'
    },
    {
        name: '增值服务类型',
        value: 'addedServiceType',
        optionNum: 'ADDED_SERVICE',
        options: [],
        filterable: true,
        type: 'select'
    },
    {
        name: '来源系统',
        value: 'sourceSystem',
        optionNum: 'SOURCE_SYSTEM',
        options: [],
        filterable: true,
        type: 'select'
    },
    {
        name: '服务单号',
        value: 'serviceOrderNo',
        type: 'input'
    },
    {
        name: '收货联系人',
        value: 'receiverName',
        type: 'input'
    },
    {
        name: '收货市',
        value: 'receiverCityName',
        advanceConfig: [{
            prop: 'ebplNameCn',
            value: '收货市名称'
        },
        {
            prop: 'ebplCode',
            value: '收货市编码'
        }
        ],
        tableConfig: [{
            prop: 'ebplNameCn',
            value: '收货市名称'
        },
        {
            prop: 'ebplCode',
            value: '收货市编码'
        }
        ],
        advanceUrl: '/searchEbPlacePage?ebplType=PLACE_CITY',
        cbParams: ['ebplCode#receiverCityCode', 'ebplNameCn#receiverCityName'],
        type: 'advance'
    },
    {
        name: '收货区县',
        value: 'receiverDistrictName',
        advanceConfig: [{
            prop: 'ebplNameCn',
            value: '收货区县名称'
        },
        {
            prop: 'ebplCode',
            value: '收货区县编码'
        }
        ],
        tableConfig: [{
            prop: 'ebplNameCn',
            value: '收货区县名称'
        },
        {
            prop: 'ebplCode',
            value: '收货区县编码'
        }
        ],
        advanceUrl: '/searchEbPlacePage?ebplType=PLACE_DISTRICT',
        cbParams: ['ebplCode#receiverDistrictCode', 'ebplNameCn#receiverDistrictName'],
        type: 'advance'
    },
    {
        name: '收货乡镇',
        value: 'receiverTownName',
        advanceConfig: [{
            prop: 'ebplNameCn',
            value: '收货乡镇名称'
        },
        {
            prop: 'ebplCode',
            value: '收货乡镇编码'
        }
        ],
        tableConfig: [{
            prop: 'ebplNameCn',
            value: '收货乡镇名称'
        },
        {
            prop: 'ebplCode',
            value: '收货乡镇编码'
        }
        ],
        advanceUrl: '/searchEbPlacePage?ebplType=PLACE_STREET',
        cbParams: ['ebplCode#receiverTownCode', 'ebplNameCn#receiverTownName'],
        type: 'advance'
    },
    {
        name: '网点分中心',
        value: 'networkCenterName',
        type: 'input'
    },
    {
        name: '网点名称',
        value: 'networkName',
        advanceConfig: [{
            prop: 'netName',
            value: '网点名称'
        },
        {
            prop: 'netCode',
            value: '网点编码'
        }
        ],
        tableConfig: [{
            prop: 'netCode',
            value: '网点编码'
        },
        {
            prop: 'netName',
            value: '网点名称'
        }
        ],
        advanceUrl: '/netInfos',
        cbParams: ['netCode#networkCode', 'netName#networkName'],
        type: 'advance'
    },
    {
        name: '网点预约备注',
        value: 'networkAppointmentRemark',
        type: 'input'
    },
    {
        name: '订单类型',
        value: 'orderType',
        multiple: true,
        type: 'select',
        filterable: true,
        optionNum: 'NET_ORDER_TYPE',
        options: []
    },
    {
        name: '配送方式',
        value: 'deliveryType',
        type: 'select',
        optionNum: 'DELIVERY_TYPE',
        filterable: true,
        options: []
    },
    {
        name: '电子签收标识',
        value: 'deliveredVerifyFlag',
        type: 'select',
        optionNum: 'DELIVERED_VERIFY_FLAG',
        options: []
    },
    {
        name: '安装状态',
        value: 'installStatus',
        type: 'select',
        filterable: true,
        optionNum: 'INSTALL_STATUS',
        options: []
    },
    {
        name: '是否精准配送',
        value: 'isJzp',
        type: 'select',
        options: [{ 'value': 'Y', 'label': '是' }, { 'value': 'N', 'label': '否' }]
    }
    ],
    logTable: {
        height: '375px',
        border: true,
        selection: false,
        isPagination: true,
        columns: [{
            prop: 'operateType',
            label: '操作类型',
            type: 'normal',
            width: '160px'
        },
        {
            prop: 'operateContent',
            label: '操作内容',
            type: 'normal',
            width: '360px'
        },
        {
            prop: 'createUserCode',
            label: '操作人',
            type: 'normal',
            width: '140px'
        },
        {
            prop: 'createTime',
            label: '操作时间',
            type: 'normal',
            width: '140px'
        }
        ]
    }
};
